var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 32.4C23.2843 32.4 30 25.6843 30 17.4C30 9.11572 23.2843 2.39999 15 2.39999C6.71573 2.39999 0 9.11572 0 17.4C0 25.6843 6.71573 32.4 15 32.4Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6133 19.0234H15.9844V23.6523H14.0508V19.0234H9.42188V17.0898H14.0508V12.4492H15.9844V17.0898H20.6133V19.0234Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddGrey);
export default __webpack_public_path__ + "static/media/Icon_Add_Grey.8bb53c71dbd2eb40c1cadad29f78df91.svg";
export { ForwardRef as ReactComponent };